/*
Development: 
  npm start → NODE_ENV=development → Uses LOCAL URLs
Production: 
  npm run build → NODE_ENV=production → Uses REMOTE URLs
*/

// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development'


// Get protocol from current URL (http:// or https://)
const getProtocol = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.protocol === 'https:' ? 'https://' : 'http://'
  }
  return 'http://' // Default to https:// for SSR
}

const protocol = getProtocol()
// Base environment configuration
export const ENV = {
  LOCAL_SERVER_URL: 'http://localhost:4000/',
  LOCAL_FILE_UPLOAD_URL: 'http://localhost:4001/upload',
  LOCAL_FILE_MOVE_URL: 'http://localhost:4001/move-file/:id',
  LOCAL_FILE_DELETE_URL: 'http://localhost:4001/delete/:id',
  REMOTE_SERVER_URL: `https://admin-api.snapcollars.com.au/`,
  REMOTE_FILE_UPLOAD_URL: `https://admin-api.snapcollars.com.au/upload`,
  REMOTE_FILE_MOVE_URL: `https://admin-api.snapcollars.com.au/move-file/:id`,
  REMOTE_FILE_DELETE_URL: `https://admin-api.snapcollars.com.au/delete/:id`
}

// Environment-based URL selector
export const getEnvironmentURL = {
  // Server URL selection
  server: isDevelopment ? ENV.LOCAL_SERVER_URL : ENV.REMOTE_SERVER_URL,

  // File operation URL selection
  fileUpload: isDevelopment ? ENV.LOCAL_FILE_UPLOAD_URL : ENV.REMOTE_FILE_UPLOAD_URL,

  // File move URL with ID replacement
  fileMove: (id: string): string => {
    const baseURL = isDevelopment ? ENV.LOCAL_FILE_MOVE_URL : ENV.REMOTE_FILE_MOVE_URL
    return baseURL.replace(':id', id)
  },

  // File delete URL with ID replacement
  fileDelete: (id: string): string => {
    const baseURL = isDevelopment ? ENV.LOCAL_FILE_DELETE_URL : ENV.REMOTE_FILE_DELETE_URL
    return baseURL.replace(':id', id)
  }
}

// Legacy support - maintain backward compatibility
export const ENV_LEGACY = {
  ...ENV,
  // Override with environment-based selection for backward compatibility
  SERVER_URL: getEnvironmentURL.server,
  FILE_UPLOAD_URL: getEnvironmentURL.fileUpload
}
